// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: types/query_quotes.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "../../binary";
import { DeepPartial, Exact, isSet } from "../../helpers";
export const protobufPackage = "types";

export interface QueryQuoteSwapRequest {
  fromAsset: string;
  toAsset: string;
  amount: string;
  streamingInterval: string;
  streamingQuantity: string;
  destination: string;
  toleranceBps: string;
  liquidityToleranceBps: string;
  refundAddress: string;
  affiliate: string;
  affiliateBps: string;
  height: string;
}

export interface QueryQuoteSwapResponse {
  /** the inbound address for the transaction on the source chain */
  inboundAddress: string;
  /** the approximate number of source chain blocks required before processing */
  inboundConfirmationBlocks: number;
  /** the approximate seconds for block confirmations required before processing */
  inboundConfirmationSeconds: number;
  /** the number of thorchain blocks the outbound will be delayed */
  outboundDelayBlocks: number;
  /** the approximate seconds for the outbound delay before it will be sent */
  outboundDelaySeconds: number;
  fees: QuoteFees | undefined;
  /** the EVM chain router contract address */
  router: string;
  /** expiration timestamp in unix seconds */
  expiry: number;
  /** static warning message */
  warning: string;
  /** chain specific quote notes */
  notes: string;
  /** Defines the minimum transaction size for the chain in base units (sats, wei, uatom). Transactions with asset amounts lower than the dust_threshold are ignored. */
  dustThreshold: string;
  /** The recommended minimum inbound amount for this transaction type & inbound asset. Sending less than this amount could result in failed refunds. */
  recommendedMinAmountIn: string;
  /** the recommended gas rate to use for the inbound to ensure timely confirmation */
  recommendedGasRate: string;
  /** the units of the recommended gas rate */
  gasRateUnits: string;
  /** generated memo for the swap */
  memo: string;
  /** the amount of the target asset the user can expect to receive after fees */
  expectedAmountOut: string;
  /** the amount of the target asset the user can expect to receive after fees */
  maxStreamingQuantity: number;
  /** the number of blocks the streaming swap will execute over */
  streamingSwapBlocks: number;
  /** approx the number of seconds the streaming swap will execute over */
  streamingSwapSeconds: number;
  /** total number of seconds a swap is expected to take (inbound conf + streaming swap + outbound delay) */
  totalSwapSeconds: number;
}

export interface QuoteFees {
  /** the target asset used for all fees */
  asset: string;
  /** affiliate fee in the target asset */
  affiliate: string;
  /** outbound fee in the target asset */
  outbound: string;
  /** liquidity fees paid to pools in the target asset */
  liquidity: string;
  /** total fees in the target asset */
  total: string;
  /** the swap slippage in basis points */
  slippageBps: number;
  /** total basis points in fees relative to amount out */
  totalBps: number;
}

function createBaseQueryQuoteSwapRequest(): QueryQuoteSwapRequest {
  return {
    fromAsset: "",
    toAsset: "",
    amount: "",
    streamingInterval: "",
    streamingQuantity: "",
    destination: "",
    toleranceBps: "",
    liquidityToleranceBps: "",
    refundAddress: "",
    affiliate: "",
    affiliateBps: "",
    height: "",
  };
}

export const QueryQuoteSwapRequest = {
  encode(
    message: QueryQuoteSwapRequest,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.fromAsset !== "") {
      writer.uint32(10).string(message.fromAsset);
    }
    if (message.toAsset !== "") {
      writer.uint32(18).string(message.toAsset);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.streamingInterval !== "") {
      writer.uint32(34).string(message.streamingInterval);
    }
    if (message.streamingQuantity !== "") {
      writer.uint32(42).string(message.streamingQuantity);
    }
    if (message.destination !== "") {
      writer.uint32(50).string(message.destination);
    }
    if (message.toleranceBps !== "") {
      writer.uint32(58).string(message.toleranceBps);
    }
    if (message.refundAddress !== "") {
      writer.uint32(66).string(message.refundAddress);
    }
    if (message.affiliate !== "") {
      writer.uint32(74).string(message.affiliate);
    }
    if (message.affiliateBps !== "") {
      writer.uint32(82).string(message.affiliateBps);
    }
    if (message.height !== "") {
      writer.uint32(90).string(message.height);
    }
    if (message.liquidityToleranceBps !== "") {
      writer.uint32(98).string(message.liquidityToleranceBps);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): QueryQuoteSwapRequest {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryQuoteSwapRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.fromAsset = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.toAsset = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.streamingInterval = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.streamingQuantity = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.destination = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.toleranceBps = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.refundAddress = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.affiliate = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.affiliateBps = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.height = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.liquidityToleranceBps = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueryQuoteSwapRequest {
    return {
      fromAsset: isSet(object.fromAsset)
        ? globalThis.String(object.fromAsset)
        : "",
      toAsset: isSet(object.toAsset) ? globalThis.String(object.toAsset) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      streamingInterval: isSet(object.streamingInterval)
        ? globalThis.String(object.streamingInterval)
        : "",
      streamingQuantity: isSet(object.streamingQuantity)
        ? globalThis.String(object.streamingQuantity)
        : "",
      destination: isSet(object.destination)
        ? globalThis.String(object.destination)
        : "",
      toleranceBps: isSet(object.toleranceBps)
        ? globalThis.String(object.toleranceBps)
        : "",
      liquidityToleranceBps: isSet(object.liquidityToleranceBps)
        ? globalThis.String(object.liquidityToleranceBps)
        : "",
      refundAddress: isSet(object.refundAddress)
        ? globalThis.String(object.refundAddress)
        : "",
      affiliate: isSet(object?.affiliate)
        ? globalThis.String(object.affiliate)
        : "",
      affiliateBps: isSet(object?.affiliateBps)
        ? globalThis.String(object.affiliateBps)
        : "",
      height: isSet(object.height) ? globalThis.String(object.height) : "",
    };
  },

  toJSON(message: QueryQuoteSwapRequest): unknown {
    const obj: any = {};
    if (message.fromAsset !== "") {
      obj.fromAsset = message.fromAsset;
    }
    if (message.toAsset !== "") {
      obj.toAsset = message.toAsset;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.streamingInterval !== "") {
      obj.streamingInterval = message.streamingInterval;
    }
    if (message.streamingQuantity !== "") {
      obj.streamingQuantity = message.streamingQuantity;
    }
    if (message.destination !== "") {
      obj.destination = message.destination;
    }
    if (message.toleranceBps !== "") {
      obj.toleranceBps = message.toleranceBps;
    }
    if (message.refundAddress !== "") {
      obj.refundAddress = message.refundAddress;
    }
    if (message.affiliate !== "") {
      obj.affiliate = message.affiliate;
    }
    if (message.refundAddress !== "") {
      obj.refundAddress = message.refundAddress;
    }
    if (message.height !== "") {
      obj.height = message.height;
    }
    if (message.liquidityToleranceBps !== "") {
      obj.liquidityToleranceBps = message.liquidityToleranceBps;
    }

    return obj;
  },

  create<I extends Exact<DeepPartial<QueryQuoteSwapRequest>, I>>(
    base?: I
  ): QueryQuoteSwapRequest {
    return QueryQuoteSwapRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueryQuoteSwapRequest>, I>>(
    object: I
  ): QueryQuoteSwapRequest {
    const message = createBaseQueryQuoteSwapRequest();
    message.fromAsset = object.fromAsset ?? "";
    message.toAsset = object.toAsset ?? "";
    message.amount = object.amount ?? "";
    message.streamingInterval = object.streamingInterval ?? "";
    message.streamingQuantity = object.streamingQuantity ?? "";
    message.destination = object.destination ?? "";
    message.toleranceBps = object.toleranceBps ?? "";
    message.refundAddress = object.refundAddress ?? "";
    message.affiliate = object.affiliate ?? "";
    message.affiliateBps = object.affiliateBps ?? "";
    message.height = object.height ?? "";
    message.liquidityToleranceBps = object.liquidityToleranceBps ?? "";
    return message;
  },
};

function createBaseQueryQuoteSwapResponse(): QueryQuoteSwapResponse {
  return {
    inboundAddress: "",
    inboundConfirmationBlocks: 0,
    inboundConfirmationSeconds: 0,
    outboundDelayBlocks: 0,
    outboundDelaySeconds: 0,
    fees: undefined,
    router: "",
    expiry: 0,
    warning: "",
    notes: "",
    dustThreshold: "",
    recommendedMinAmountIn: "",
    recommendedGasRate: "",
    gasRateUnits: "",
    memo: "",
    expectedAmountOut: "",
    maxStreamingQuantity: 0,
    streamingSwapBlocks: 0,
    streamingSwapSeconds: 0,
    totalSwapSeconds: 0,
  };
}

export const QueryQuoteSwapResponse = {
  encode(
    message: QueryQuoteSwapResponse,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.inboundAddress !== "") {
      writer.uint32(10).string(message.inboundAddress);
    }
    if (message.inboundConfirmationBlocks !== 0) {
      writer.uint32(16).int64(message.inboundConfirmationBlocks);
    }
    if (message.inboundConfirmationSeconds !== 0) {
      writer.uint32(24).int64(message.inboundConfirmationSeconds);
    }
    if (message.outboundDelayBlocks !== 0) {
      writer.uint32(32).int64(message.outboundDelayBlocks);
    }
    if (message.outboundDelaySeconds !== 0) {
      writer.uint32(40).int64(message.outboundDelaySeconds);
    }
    if (message.fees !== undefined) {
      QuoteFees.encode(message.fees, writer.uint32(50).fork()).ldelim();
    }
    if (message.router !== "") {
      writer.uint32(58).string(message.router);
    }
    if (message.expiry !== 0) {
      writer.uint32(64).int64(message.expiry);
    }
    if (message.warning !== "") {
      writer.uint32(74).string(message.warning);
    }
    if (message.notes !== "") {
      writer.uint32(82).string(message.notes);
    }
    if (message.dustThreshold !== "") {
      writer.uint32(90).string(message.dustThreshold);
    }
    if (message.recommendedMinAmountIn !== "") {
      writer.uint32(98).string(message.recommendedMinAmountIn);
    }
    if (message.recommendedGasRate !== "") {
      writer.uint32(106).string(message.recommendedGasRate);
    }
    if (message.gasRateUnits !== "") {
      writer.uint32(114).string(message.gasRateUnits);
    }
    if (message.memo !== "") {
      writer.uint32(122).string(message.memo);
    }
    if (message.expectedAmountOut !== "") {
      writer.uint32(130).string(message.expectedAmountOut);
    }
    if (message.maxStreamingQuantity !== 0) {
      writer.uint32(136).int64(message.maxStreamingQuantity);
    }
    if (message.streamingSwapBlocks !== 0) {
      writer.uint32(144).int64(message.streamingSwapBlocks);
    }
    if (message.streamingSwapSeconds !== 0) {
      writer.uint32(152).int64(message.streamingSwapSeconds);
    }
    if (message.totalSwapSeconds !== 0) {
      writer.uint32(160).int64(message.totalSwapSeconds);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): QueryQuoteSwapResponse {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryQuoteSwapResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.inboundAddress = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.inboundConfirmationBlocks = Number(reader.int64());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.inboundConfirmationSeconds = Number(reader.int64());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.outboundDelayBlocks = Number(reader.int64());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.outboundDelaySeconds = Number(reader.int64());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.fees = QuoteFees.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.router = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.expiry = Number(reader.int64());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.warning = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.dustThreshold = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.recommendedMinAmountIn = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.recommendedGasRate = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.gasRateUnits = reader.string();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.memo = reader.string();
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.expectedAmountOut = reader.string();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.maxStreamingQuantity = Number(reader.int64());
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.streamingSwapBlocks = Number(reader.int64());
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.streamingSwapSeconds = Number(reader.int64());
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.totalSwapSeconds = Number(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueryQuoteSwapResponse {
    return {
      inboundAddress: isSet(object.inboundAddress)
        ? globalThis.String(object.inboundAddress)
        : "",
      inboundConfirmationBlocks: isSet(object.inboundConfirmationBlocks)
        ? globalThis.Number(object.inboundConfirmationBlocks)
        : 0,
      inboundConfirmationSeconds: isSet(object.inboundConfirmationSeconds)
        ? globalThis.Number(object.inboundConfirmationSeconds)
        : 0,
      outboundDelayBlocks: isSet(object.outboundDelayBlocks)
        ? globalThis.Number(object.outboundDelayBlocks)
        : 0,
      outboundDelaySeconds: isSet(object.outboundDelaySeconds)
        ? globalThis.Number(object.outboundDelaySeconds)
        : 0,
      fees: isSet(object.fees) ? QuoteFees.fromJSON(object.fees) : undefined,
      router: isSet(object.router) ? globalThis.String(object.router) : "",
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      warning: isSet(object.warning) ? globalThis.String(object.warning) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      dustThreshold: isSet(object.dustThreshold)
        ? globalThis.String(object.dustThreshold)
        : "",
      recommendedMinAmountIn: isSet(object.recommendedMinAmountIn)
        ? globalThis.String(object.recommendedMinAmountIn)
        : "",
      recommendedGasRate: isSet(object.recommendedGasRate)
        ? globalThis.String(object.recommendedGasRate)
        : "",
      gasRateUnits: isSet(object.gasRateUnits)
        ? globalThis.String(object.gasRateUnits)
        : "",
      memo: isSet(object.memo) ? globalThis.String(object.memo) : "",
      expectedAmountOut: isSet(object.expectedAmountOut)
        ? globalThis.String(object.expectedAmountOut)
        : "",
      maxStreamingQuantity: isSet(object.maxStreamingQuantity)
        ? globalThis.Number(object.maxStreamingQuantity)
        : 0,
      streamingSwapBlocks: isSet(object.streamingSwapBlocks)
        ? globalThis.Number(object.streamingSwapBlocks)
        : 0,
      streamingSwapSeconds: isSet(object.streamingSwapSeconds)
        ? globalThis.Number(object.streamingSwapSeconds)
        : 0,
      totalSwapSeconds: isSet(object.totalSwapSeconds)
        ? globalThis.Number(object.totalSwapSeconds)
        : 0,
    };
  },

  toJSON(message: QueryQuoteSwapResponse): unknown {
    const obj: any = {};
    if (message.inboundAddress !== "") {
      obj.inboundAddress = message.inboundAddress;
    }
    if (message.inboundConfirmationBlocks !== 0) {
      obj.inboundConfirmationBlocks = Math.round(
        message.inboundConfirmationBlocks
      );
    }
    if (message.inboundConfirmationSeconds !== 0) {
      obj.inboundConfirmationSeconds = Math.round(
        message.inboundConfirmationSeconds
      );
    }
    if (message.outboundDelayBlocks !== 0) {
      obj.outboundDelayBlocks = Math.round(message.outboundDelayBlocks);
    }
    if (message.outboundDelaySeconds !== 0) {
      obj.outboundDelaySeconds = Math.round(message.outboundDelaySeconds);
    }
    if (message.fees !== undefined) {
      obj.fees = QuoteFees.toJSON(message.fees);
    }
    if (message.router !== "") {
      obj.router = message.router;
    }
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.warning !== "") {
      obj.warning = message.warning;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.dustThreshold !== "") {
      obj.dustThreshold = message.dustThreshold;
    }
    if (message.recommendedMinAmountIn !== "") {
      obj.recommendedMinAmountIn = message.recommendedMinAmountIn;
    }
    if (message.recommendedGasRate !== "") {
      obj.recommendedGasRate = message.recommendedGasRate;
    }
    if (message.gasRateUnits !== "") {
      obj.gasRateUnits = message.gasRateUnits;
    }
    if (message.memo !== "") {
      obj.memo = message.memo;
    }
    if (message.expectedAmountOut !== "") {
      obj.expectedAmountOut = message.expectedAmountOut;
    }
    if (message.maxStreamingQuantity !== 0) {
      obj.maxStreamingQuantity = Math.round(message.maxStreamingQuantity);
    }
    if (message.streamingSwapBlocks !== 0) {
      obj.streamingSwapBlocks = Math.round(message.streamingSwapBlocks);
    }
    if (message.streamingSwapSeconds !== 0) {
      obj.streamingSwapSeconds = Math.round(message.streamingSwapSeconds);
    }
    if (message.totalSwapSeconds !== 0) {
      obj.totalSwapSeconds = Math.round(message.totalSwapSeconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueryQuoteSwapResponse>, I>>(
    base?: I
  ): QueryQuoteSwapResponse {
    return QueryQuoteSwapResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueryQuoteSwapResponse>, I>>(
    object: I
  ): QueryQuoteSwapResponse {
    const message = createBaseQueryQuoteSwapResponse();
    message.inboundAddress = object.inboundAddress ?? "";
    message.inboundConfirmationBlocks = object.inboundConfirmationBlocks ?? 0;
    message.inboundConfirmationSeconds = object.inboundConfirmationSeconds ?? 0;
    message.outboundDelayBlocks = object.outboundDelayBlocks ?? 0;
    message.outboundDelaySeconds = object.outboundDelaySeconds ?? 0;
    message.fees =
      object.fees !== undefined && object.fees !== null
        ? QuoteFees.fromPartial(object.fees)
        : undefined;
    message.router = object.router ?? "";
    message.expiry = object.expiry ?? 0;
    message.warning = object.warning ?? "";
    message.notes = object.notes ?? "";
    message.dustThreshold = object.dustThreshold ?? "";
    message.recommendedMinAmountIn = object.recommendedMinAmountIn ?? "";
    message.recommendedGasRate = object.recommendedGasRate ?? "";
    message.gasRateUnits = object.gasRateUnits ?? "";
    message.memo = object.memo ?? "";
    message.expectedAmountOut = object.expectedAmountOut ?? "";
    message.maxStreamingQuantity = object.maxStreamingQuantity ?? 0;
    message.streamingSwapBlocks = object.streamingSwapBlocks ?? 0;
    message.streamingSwapSeconds = object.streamingSwapSeconds ?? 0;
    message.totalSwapSeconds = object.totalSwapSeconds ?? 0;
    return message;
  },
};

function createBaseQuoteFees(): QuoteFees {
  return {
    asset: "",
    affiliate: "",
    outbound: "",
    liquidity: "",
    total: "",
    slippageBps: 0,
    totalBps: 0,
  };
}

export const QuoteFees = {
  encode(
    message: QuoteFees,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.asset !== "") {
      writer.uint32(10).string(message.asset);
    }
    if (message.affiliate !== "") {
      writer.uint32(18).string(message.affiliate);
    }
    if (message.outbound !== "") {
      writer.uint32(26).string(message.outbound);
    }
    if (message.liquidity !== "") {
      writer.uint32(34).string(message.liquidity);
    }
    if (message.total !== "") {
      writer.uint32(42).string(message.total);
    }
    if (message.slippageBps !== 0) {
      writer.uint32(48).int64(message.slippageBps);
    }
    if (message.totalBps !== 0) {
      writer.uint32(56).int64(message.totalBps);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuoteFees {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuoteFees();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.asset = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.affiliate = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.outbound = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.liquidity = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.total = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.slippageBps = Number(reader.int64());
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.totalBps = Number(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuoteFees {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : "",
      affiliate: isSet(object.affiliate)
        ? globalThis.String(object.affiliate)
        : "",
      outbound: isSet(object.outbound)
        ? globalThis.String(object.outbound)
        : "",
      liquidity: isSet(object.liquidity)
        ? globalThis.String(object.liquidity)
        : "",
      total: isSet(object.total) ? globalThis.String(object.total) : "",
      slippageBps: isSet(object.slippageBps)
        ? globalThis.Number(object.slippageBps)
        : 0,
      totalBps: isSet(object.totalBps) ? globalThis.Number(object.totalBps) : 0,
    };
  },

  toJSON(message: QuoteFees): unknown {
    const obj: any = {};
    if (message.asset !== "") {
      obj.asset = message.asset;
    }
    if (message.affiliate !== "") {
      obj.affiliate = message.affiliate;
    }
    if (message.outbound !== "") {
      obj.outbound = message.outbound;
    }
    if (message.liquidity !== "") {
      obj.liquidity = message.liquidity;
    }
    if (message.total !== "") {
      obj.total = message.total;
    }
    if (message.slippageBps !== 0) {
      obj.slippageBps = Math.round(message.slippageBps);
    }
    if (message.totalBps !== 0) {
      obj.totalBps = Math.round(message.totalBps);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QuoteFees>, I>>(base?: I): QuoteFees {
    return QuoteFees.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuoteFees>, I>>(
    object: I
  ): QuoteFees {
    const message = createBaseQuoteFees();
    message.asset = object.asset ?? "";
    message.affiliate = object.affiliate ?? "";
    message.outbound = object.outbound ?? "";
    message.liquidity = object.liquidity ?? "";
    message.total = object.total ?? "";
    message.slippageBps = object.slippageBps ?? 0;
    message.totalBps = object.totalBps ?? 0;
    return message;
  },
};
